import "./BurgerMenu.css";

import { ReactComponent as Cross } from "@icons/cross.svg";
import { PropsWithChildren } from "react";
import classNames from "classnames";

export type BurgerMenuProps = {
  fullHeight?: boolean;
  topInsetPadding?: number;
  heading?: string;
  isOpen: boolean;
  onCloseClick: VoidFunction;
  onCloseFinished?: VoidFunction;
  className?: string;
  closeButtionAriaLabel?: string;
} & PropsWithChildren;

export const BurgerMenu = ({
  fullHeight,
  topInsetPadding,
  heading,
  isOpen,
  onCloseClick,
  onCloseFinished,
  className,
  closeButtionAriaLabel,
  children,
}: BurgerMenuProps) => {
  const getHeightClass = () => {
    let heightClass = "h-[calc(100%-10rem)] lg:h-full";

    if (!topInsetPadding && fullHeight) {
      heightClass = "h-full";
    }

    if (topInsetPadding) {
      heightClass = "h-[calc(100%-5rem)]";
    }

    return heightClass;
  };

  return (
    <div
      onTransitionEnd={() => {
        if (!isOpen) {
          onCloseFinished?.();
        }
      }}
      style={{
        top: topInsetPadding ? `${topInsetPadding + 80}px` : "80px",
      }}
      className={classNames(getHeightClass(), "fixed w-[80%] md:w-[40%] burger-menu bg-white z-50 left-0 px-10 py-6 overflow-y-auto", {
        className: !!className,
        "open-menu": isOpen === true,
        "closed-menu": isOpen === false,
      })}
    >
      <div className={classNames("flex justify-end w-full pb-2", { "justify-between": !!heading })}>
        {heading && <h3 className="self-start">{heading}</h3>}
        <button onClick={onCloseClick} className="self-start pt-1 pr-4" aria-label={closeButtionAriaLabel}>
          <Cross className="h-5" />
        </button>
      </div>
      {children}
    </div>
  );
};
